// // src/hooks/useRegisterFcm.js
// import { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { registerFcmToken } from ".././Redux/Slice/Doctor/callSlice";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { firebaseApp } from "./firebase"; // make sure firebaseApp is exported

// const useRegisterFcm = (userId) => {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (!userId) return;

//     const registerToken = async () => {
//       try {
//         const messaging = getMessaging(firebaseApp);

//         // Request permission for notifications
//         const permission = await Notification.requestPermission();
//         if (permission !== "granted") {
//           console.warn("Notification permission not granted");
//           return;
//         }

//         // Get FCM token
//         const token = await getToken(messaging, {
//           vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
//         });

//         if (token) {
//           dispatch(
//             registerFcmToken({
//               userId,
//               fcmToken: token,
//               deviceType: "WEB",
//             })
//           );
//         }

//         // Optional: listen to foreground messages
//         onMessage(messaging, (payload) => {
//           console.log("Message received. ", payload);
//         });
//       } catch (error) {
//         console.error("FCM token registration failed:", error);
//       }
//     };

//     registerToken();
//   }, [userId, dispatch]);
// };

// export default useRegisterFcm;

// src/hooks/useRegisterFcm.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { registerFcmToken } from "../Redux/Slice/Doctor/callSlice";

const useRegisterFcm = (userId) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userId) return;

    // Dispatch the registerFcmToken thunk
    dispatch(registerFcmToken({ userId, deviceType: "WEB" }));
  }, [userId, dispatch]);
};

export default useRegisterFcm;

